var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-frame-editor-context-menu',{on:{"click":_vm.onMenuClick}},[_c('m-frame-editor-layout',{ref:"layout",scopedSlots:_vm._u([{key:"toolbar",fn:function(){return [_c('m-key-context',{ref:"context",on:{"keyup":_vm.onKeyup}},[_c('m-frame-editor-actions',{ref:"actions",on:{"skip":_vm.onSkip,"zoom":_vm.onZoom,"download":_vm.onDownload}})],1)]},proxy:true},{key:"table",fn:function(){return [_c('m-frame-editor-tab',{attrs:{"isLoading":_vm.syncing},on:{"update-point":function($event){return _vm.$store.dispatch('current/frame/updatePoint', $event)},"update-rect":function($event){return _vm.$store.dispatch('current/frame/updateRect', $event)}}})]},proxy:true}])},[_c('m-key-context',{ref:"context",on:{"keyup":_vm.onKeyup}},[(!_vm.syncing)?_c('v-stage',{ref:"stage",attrs:{"config":{ width: _vm.cw, height: _vm.ch }},on:{"mousemove":_vm.onStageMouseMove,"mousedown":_vm.onStageMouseDown,"mouseup":_vm.onStageMouseUp}},[_c('v-layer',{ref:"layer"},[_c('v-image',{ref:"background",attrs:{"config":_vm.background},on:{"dblclick":_vm.onDblClick}})],1),_vm._l((_vm.polygons),function(_p){return _c('v-layer',{key:_p.id,ref:"layer",refInFor:true},[_vm._l((_p.lines),function(x){return _c('v-line',{key:((_p.id) + "-" + (x.id)),attrs:{"config":{
              id: ("polygon-" + (_p.id) + "-" + (x.id)),
              polygon_id: _p.id,
              line_id: x.id,
              points: x.points,
              stroke: _p.color || _vm.polygon.conf.color,
              strokeWidth:
                _vm.mode == 'pen' ? 3 : _p.size || _vm.polygon.conf.size,
              lineCap: 'round',
              lineJoin: 'round'
            }},on:{"dblclick":_vm.onPolygonLineDblClick}})}),_vm._l((_p.points),function(x){return _c('v-circle',{key:("polygon-" + (_p.id) + "-point-" + (x.id)),attrs:{"config":{
              id: ("polygon-" + (_p.id) + "-point-" + (x.id)),
              polygon_id: _p.id,
              point_id: x.id,
              x: x.x,
              y: x.y,
              stroke: 'white',
              strokeWidth: _vm.mode == 'pen' ? 0 : 1,
              radius:
                _vm.mode == 'pen' ? 0 : x.size || _vm.polygon.conf.size,
              fill: _p.color || _vm.polygon.conf.color
            }},on:{"click":_vm.onPolygonPointClick,"mouseenter":_vm.onPolygonPointMouseEnter,"mouseleave":_vm.onPolygonPointMouseLeave}})})],2)}),_c('v-layer',{ref:"layer"},[_vm._l((_vm.ruler.points),function(x){return _c('v-circle',{key:x.id,attrs:{"config":{
              id: x.id,
              x: x.x,
              y: x.y,
              stroke: 'white',
              strokeWidth: 1,
              radius: _vm.ruler.conf.size,
              fill: _vm.ruler.conf.color
            }}})}),_vm._l((_vm.ruler.lines),function(x){return _c('v-line',{key:x.id,attrs:{"config":{
              id: x.id,
              points: x.points,
              stroke:
                _vm.ruler.active == x.id
                  ? _vm.ruler.conf.activeColor
                  : _vm.ruler.conf.color,
              strokeWidth:
                _vm.ruler.active == x.id
                  ? _vm.ruler.conf.activeSize
                  : _vm.ruler.conf.size,
              lineCap: 'round',
              lineJoin: 'round',
              dash: [5, 10]
            }},on:{"mouseenter":_vm.onRulerMouseEnter,"mouseleave":_vm.onRulerMouseLeave,"dblclick":_vm.onRulerDblClick}})}),_vm._l((_vm.polygon.lines),function(x){return _c('v-line',{key:("polygon-" + (x.id)),attrs:{"config":{
              id: ("polygon-" + (x.id)),
              points: x.points,
              stroke:
                _vm.polygon.active === true
                  ? _vm.polygon.conf.activeColor
                  : _vm.polygon.conf.color,
              strokeWidth: _vm.mode == 'pen' ? 2 : _vm.polygon.conf.size,
              lineCap: 'round',
              lineJoin: 'round'
            }}})}),_vm._l((_vm.cpStartPoints),function(x){return _c('v-circle',{key:x.id,attrs:{"config":{
              id: ("polygon-" + (x.id)),
              x: x.x,
              y: x.y,
              stroke: 'white',
              strokeWidth: 1,
              radius: _vm.mode == 'pen' ? 0 : _vm.polygon.conf.size,
              fill:
                _vm.polygon.active === true
                  ? _vm.polygon.conf.activeColor
                  : _vm.polygon.conf.color
            }},on:{"mouseenter":_vm.onPolygonMouseEnter,"mouseleave":_vm.onPolygonMouseLeave,"click":_vm.onClickPolygonsPoint}})}),_vm._l((_vm.cpPoints),function(x){return _c('v-circle',{key:x.id,attrs:{"config":{
              id: ("polygon-" + (x.id)),
              x: x.x,
              y: x.y,
              stroke: 'white',
              strokeWidth: 1,
              radius: _vm.mode == 'pen' ? 0 : _vm.polygon.conf.size,
              fill:
                _vm.polygon.active === true
                  ? _vm.polygon.conf.activeColor
                  : _vm.polygon.conf.color
            }}})}),_vm._l((_vm.rects),function(x){return _c('v-rect',{key:x.name,attrs:{"config":{
              name: x.name,
              id: x.id,
              x: x.x,
              y: x.y,
              width: x.width,
              height: x.height,
              rotation: x.rotation || 1,
              scaleX: x.scaleX || 1,
              scaleY: x.scaleY || 1,
              strokeWidth: x.size || 1,
              draggable: _vm.mode == 'rect',
              stroke: _vm.colorFilter('rect', x),
              opacity: _vm.opacityFilter('rect')
            }},on:{"click":_vm.onRectClick,"dragend":_vm.onRectDragEnd,"transformend":_vm.onTransformEnd}})}),_vm._l((_vm.points),function(x,i){return _c('v-circle',{key:i,attrs:{"config":{
              id: x.id,
              x: x.x,
              y: x.y,
              stroke: 'white',
              strokeWidth: 1,
              radius: x.size,
              draggable: _vm.mode == 'circ',
              fill: _vm.colorFilter('circ', x),
              opacity: _vm.opacityFilter('circ')
            }},on:{"click":_vm.onPointClick,"mouseenter":_vm.onPointMouseEnter,"mouseleave":_vm.onPointMouseLeave,"dragstart":_vm.onPointDragStart,"dragend":_vm.onPointDragEnd}})}),(_vm.mode == 'rect')?_c('v-transformer',{ref:"transformer"}):_vm._e()],2),(_vm.cursor.show)?_c('m-frame-editor-cursor',{on:{"dblclick":_vm.onDblClick},model:{value:(_vm.cursor),callback:function ($$v) {_vm.cursor=$$v},expression:"cursor"}}):_vm._e()],2):_vm._e(),(_vm.syncing)?_c('m-loading',{attrs:{"text":"$vuetify.loading"}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }